"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var i18n_1 = __importDefault(require("../i18n"));
var CaviarOverrideTwoFactorAuthenticationStrings = {
    forSecurityIsYou: function () {
        return i18n_1["default"].t('caviar_twoFactorAuthenticationStrings_forSecurityIsYou');
    },
    tooManyAttemptsExplanation: function () {
        return i18n_1["default"].t('caviar_twoFactorAuthenticationStrings_tooManyAttemptsExplanation');
    }
};
var TwoFactorAuthenticationStrings = {
    aTextMessage: function () { return i18n_1["default"].t('twoFactorAuthenticationStrings_aTextMessage'); },
    anEmail: function () { return i18n_1["default"].t('twoFactorAuthenticationStrings_anEmail'); },
    contactSupport: function () { return i18n_1["default"].t('twoFactorAuthenticationStrings_contactSupport'); },
    enterCode: function () { return i18n_1["default"].t('twoFactorAuthenticationStrings_enterCode'); },
    errorProcessingTryAgain: function () {
        return i18n_1["default"].t('twoFactorAuthenticationStrings_errorProcessingTryAgain');
    },
    forSecurityIsYou: function () {
        return i18n_1["default"].t('twoFactorAuthenticationStrings_forSecurityIsYou');
    },
    getHelp: function () { return i18n_1["default"].t('twoFactorAuthenticationStrings_getHelp'); },
    messageWithCodeWasSent: function (messageType, address) {
        return i18n_1["default"].t('twoFactorAuthenticationStrings_messageWithCodeWasSent', {
            messageType: messageType,
            address: address
        });
    },
    resendCode: function () { return i18n_1["default"].t('twoFactorAuthenticationStrings_resendCode'); },
    sendCodeToEmail: function () {
        return i18n_1["default"].t('twoFactorAuthenticationStrings_sendCodeToEmail');
    },
    sendCodeToPhone: function () {
        return i18n_1["default"].t('twoFactorAuthenticationStrings_sendCodeToPhone');
    },
    tooManyAttemptsExplanation: function () {
        return i18n_1["default"].t('twoFactorAuthenticationStrings_tooManyAttemptsExplanation');
    },
    twoStepVerification: function () {
        return i18n_1["default"].t('twoFactorAuthenticationStrings_twoStepVerification');
    },
    verify: function () { return i18n_1["default"].t('twoFactorAuthenticationStrings_verify'); },
    wrongCodeNumTriesRemaining: function (num) {
        return i18n_1["default"].t('twoFactorAuthenticationStrings_wrongCodeNumTriesRemaining', {
            num: num
        });
    },
    caviar: CaviarOverrideTwoFactorAuthenticationStrings
};
exports["default"] = TwoFactorAuthenticationStrings;
